export default "__VITE_ASSET__L61P_BTS__"